/**
 * Initialize editorial filter
 *
 * @param {HTMLElement} root
 */
const BASE_CLASS = 'js-editorial-filter';
const FILTER_CLASS = `${BASE_CLASS}-filter`;
const SELECT_CLASS = `${BASE_CLASS}-select`;
const OPTION_CLASS = `${BASE_CLASS}-option`;
const ITEM_CLASS = `${BASE_CLASS}-item`;
const COUNT_CLASS = `${BASE_CLASS}-count`;
const IS_FILTERED = 'is-filtered';
const MAX_SHOWN_ITEMS = 7;

const handleOutsideClick = (event, element) => {
	const input = element.querySelector('input');

	let { target } = event;

	do {
		if (target === element) {
			return;
		}

		target = target.parentNode;
	} while (target);

	input.checked = false;
};

const init = (root) => {
	const filter = root.querySelector(`.${FILTER_CLASS}`);
	const selectFields = filter.querySelectorAll(`.${SELECT_CLASS}`);
	const items = root.querySelectorAll(`.${ITEM_CLASS}`);

	root.classList.add('initialized');
	filter.classList.add('initialized');

	const setFilter = () => {
		const selectedCategories = [];

		selectFields.forEach((element) => {
			const options = element.querySelectorAll(`.${OPTION_CLASS}`);
			const selectedOptions = Array.from(options).filter((option) => option.checked);
			const countElement = element.querySelector(`.${COUNT_CLASS}`);

			if (selectedOptions.length > 0) {
				element.classList.add(IS_FILTERED);
				countElement.innerHTML = `(${selectedOptions.length})`;

				Array.from(selectedOptions).forEach((option) => {
					if (option.name.length > 0) {
						selectedCategories.push(option.name);
					}
				});
			} else {
				element.classList.remove(IS_FILTERED);
				countElement.innerHTML = '';
			}
		});

		root.classList.toggle(IS_FILTERED, selectedCategories.length > 0);

		let numShownItems = 0;

		items.forEach((item) => {
			const itemCategories = item.getAttribute('data-categories')?.split(';');
			const hideItem =
				numShownItems >= MAX_SHOWN_ITEMS ||
				(selectedCategories.length > 0 &&
					!selectedCategories.some((category) => itemCategories?.includes(category)));
			const container = item.parentNode;

			if (!hideItem) {
				numShownItems++;

				container.classList.toggle('first', numShownItems === 1);
			}

			container.classList.toggle('hidden', hideItem);
			item.classList.toggle('c-editorial--default', numShownItems === 1);
			item.classList.toggle('c-editorial--grid-item', numShownItems !== 1);
		});
	};

	setFilter();
	selectFields.forEach((element) => {
		element.addEventListener('input', () => setFilter());
		document.addEventListener('click', (event) => handleOutsideClick(event, element));
	});
};

export const initEditorialFilter = (root = document) => {
	const editorialFilterModules = root.querySelectorAll(`.${BASE_CLASS}:not(.initialized)`);
	Array.from(editorialFilterModules).forEach((root) => {
		init(root);
	});
};
